module.exports = __webpack_public_path__ + "media/images/txt_line-ced3d604be51086444976868bb796874.svg";